import { type FC } from 'react'
import classNames from 'classnames'
import { type TagProps } from './Tag.interface'
import styles from './Tag.module.scss'
import { Icon } from '~/components/Icon/Icon'

export const Tag: FC<TagProps> = ({
  children,
  value,
  active,
  medium,
  small,
  variant,
  type,
  remove,
  onClick
}) => (
  type === 'button'
    ? (
      <button
        className={classNames(
          styles.container,
          medium && styles.medium,
          small && styles.small,
          active && styles['is-active'],
          variant && styles[variant]
        )}
        onClick={onClick}
      >
        {value && remove && <Icon name="#search-cross" className={styles.icon} /> }
        {children}
      </button>
      )
    : (
      <span
        className={classNames(
          styles.container,
          medium && styles.medium,
          small && styles.small,
          active && styles['is-active'],
          variant && styles[variant]
        )}
      >
        {children}
      </span>
      )
)
